export const API_CONFIG = {
  SERVER_URL: 'https://api.scfg.io',
  CHATROOM_ID: '99fca278-9975-409b-8c61-974be0e63c4c',
  API_KEY: 'tsp_6veq1SKG_qdmhOdS_eJLoZG18bpxVvmJqKa05VplLmWzjgIP8oPdyw',
  ASR_SERVICE: 'openai',
};

export const TIME_RANGES = {
  aiPending: { start: 23, end: 33.17 },
  aiStart: { start: 0, end: 11.06 },
  aiTalking: { start: 12, end: 22.5 },
};
